import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout";
import { get, post } from "../../services/ApiService";
import "../custom-style.css";
import Loader from "../../components/Loader";
import toast, { Toaster } from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import ProductInventory from "./ProductInventory";
import usePermissionCheck from "../../hooks/usePermissionCheck";
import { PRODUCT_FORMATS } from "../../utils/productFormats";
import {
  AMAZON_DEFAULT_POSTAGE_HINT,
  isAmazonDefaultPostage,
} from "../../utils/amazonPostageInfo";

const ProductEdit = () => {
  const backend_ul = process.env.REACT_APP_API_ENDPOINT;
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isNotFound, setNotFound] = useState(false);
  const [isVarSubmit, setIsVarSubmit] = useState(false);
  const [variations, setVariations] = useState([]);
  const [sqlProducts, setsqlProducts] = useState([]);
  const [vatCategories, setVatCategories] = useState([]);
  const [postages, setPostages] = useState([]);
  const [postageCodes, setPostageCodes] = useState([]);
  const canProductInputs= usePermissionCheck(['product.edit_inputs']);
  const [product, setProduct] = useState({
    title: "",
    type: "",
    enableEbayMessage: false,
    ebayMessageContent: "",
    image: "",
    purchaseLimitDays: "",
    platform: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [currentVariationIndex, setCurrentVariationIndex] = useState(null);
  const riskLevels = Array.from({ length: 70 - 14 + 1 }, (_, i) => i + 14);
  const [variationDetails, setVariationDetails] = useState({
    goodsDescription: "",
    hsCode: "",
    extendedGoodDescription: "",
  });
  const fetchProduct = async () => {
    try {
      setIsDataLoading(true);
      const res = await get(`api/products/${id}`);
      if (res.success) {
        const {
          title,
          type,
          enableEbayMessage,
          ebayMessageContent,
          ebayImage,
          purchaseLimitDays,
          platform,
          status,
        } = res.data;
        setProduct({
          title,
          type,
          enableEbayMessage,
          ebayMessageContent,
          ebayImage,
          purchaseLimitDays,
          platform,
          status,
        });
        setVariations(res.variations);
        setsqlProducts(res.sqlProducts || []);

        setVatCategories(res.vatCategories || []);
        const filteredPostages = res.postages.filter(
          (postage) => postage.type === platform || postage.type === "All"
        );
        setPostages(filteredPostages);
        setPostageCodes(res.postageCodes);
        const sProducts = res.sqlProducts;
        if (sProducts.length > 0) {
          const productOptions = sProducts.map((pro) => ({
            value: pro.id,
            label:`${pro.id} - ${pro.product}`,
          }));
          setsqlProducts(productOptions);
        }
      } else {
        setNotFound(true);
      }
    } catch (error) {
      setNotFound(true);
    } finally {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, type, checked} = e.target;
    setProduct({
      ...product,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("title", product.title);
      formData.append("type", product.type);
      formData.append("enableEbayMessage", product.enableEbayMessage);
      formData.append("ebayMessageContent", product.ebayMessageContent);
      formData.append("purchaseLimitDays", product.purchaseLimitDays);
      formData.append("status", product.status);

      // Append the image file if it exists
      if (product.image) {
        formData.append("image", product.image);
      }
      const res = await post(`api/products/update/${id}`, formData, true);
      if (res.success) {
        const {
          title,
          type,
          enableEbayMessage,
          ebayMessageContent,
          ebayImage,
          purchaseLimitDays,
          status,
        } = res.data;
        setProduct({
          title,
          type,
          enableEbayMessage,
          ebayMessageContent,
          ebayImage,
          purchaseLimitDays,
          status,
        });
        toast.success(res.message);
        setIsLoading(false);
      } else {
        toast.error(res.error);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleVarInputChange = (index, field, value) => {
    const newVariations = [...variations];
    newVariations[index][field] = value;
    setVariations(newVariations);
  };

  const handleVarPostageChange = (varIndex, postageIndex, newValue, name) => {
    const updatedVariations = [...variations];
    if (!updatedVariations[varIndex].postage) {
      updatedVariations[varIndex].postage = [];
    }
    updatedVariations[varIndex].postage[postageIndex] = {
      ...updatedVariations[varIndex].postage[postageIndex],
      name: name,
      code: newValue,
    };
    setVariations(updatedVariations);
  };

  const handleShowModal = (index, variation) => {
    setCurrentVariationIndex(index);
    setVariationDetails({
      goodsDescription: variation.goodsDescription || "",
      hsCode: variation.hsCode || "",
      extendedGoodDescription: variation.extendedGoodDescription || "",
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDetailChange = (e) => {
    const { name, value } = e.target;
    setVariationDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const saveVariationDetails = () => {
  //   const newVariations = [...variations];
  //   newVariations[currentVariationIndex] = {
  //     ...newVariations[currentVariationIndex],
  //     ...variationDetails,
  //   };
  //   setVariations(newVariations);
  //   handleCloseModal();
  // };

const handleVariationSubmit = async (e) => {
  e.preventDefault();
  try {
    setIsVarSubmit(true);
    const Body = {
      variations: variations.map((v) => ({
        SKU: v.SKU,
        name: v.name,
        format: v.format,
        weight: v.weight,
        length: v.length,
        width: v.width,
        height: v.height,
        limit: v.limit,
        riskLevel: v.riskLevel || null,
        location: v.location || "MI Health Longcroft House",
        postage: v.postage
          ? v.postage.map((p) => ({
              name: p.name,
              code: p.code || "",
            }))
          : [],
        flatPacked: v.flatPacked || false,
        extraProtection: v.extraProtection || false,
        packagingType: v.packagingType || "",
        preferredBrand: v.preferredBrand || "",
      })),
    };
    const res = await post(`api/products/variations/update/${id}`, Body);
    setIsVarSubmit(false);
    if (res.success) {
      toast.success(res.message);
    } else {
      toast.error(res.error);
    }
  } catch (error) {
    setIsVarSubmit(false);
    console.log(error);
    toast.error("An error occurred. Please try again.");
  }
};

  const saveVariationDetails = async () => {
  try {
    setIsLoading(true); // Show loading state
    
    // Prepare the data to send
    const variationToUpdate = variations[currentVariationIndex];
    const updateData = {
      SKU: variationToUpdate.SKU,
      goodsDescription: variationDetails.goodsDescription,
      hsCode: variationDetails.hsCode,
      extendedGoodDescription: variationDetails.extendedGoodDescription
    };

    // Make the API call
    const res = await post(`api/products/variation/update-details`, updateData);
    
    if (res.success) {
      // Update local state only after successful API call
      const newVariations = [...variations];
      newVariations[currentVariationIndex] = {
        ...newVariations[currentVariationIndex],
        ...variationDetails,
      };
      setVariations(newVariations);
      
      toast.success("Variation details updated successfully");
      handleCloseModal();
    } else {
      toast.error(res.error || "Failed to update variation details");
    }
  } catch (error) {
    console.error("Error updating variation details:", error);
    toast.error("An error occurred while updating variation details");
  } finally {
    setIsLoading(false);
  }
};


  return (
    <>
      <Layout>
        <div>
          <Toaster position="top-center" reverseOrder={false} />
          <div className="row mb-9 align-items-center">
            <div className="col-xxl-9">
              <div className="row">
                <div className="col-sm-6 mb-8 mb-sm-0">
                  <h2 className="fs-4 mb-0 bd-heading">Edit Product</h2>
                  <Breadcrumbs />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card mb-8 rounded-4">
                    <div className="card-body p-7">
                      {isDataLoading && (
                        <div className="text-center">
                          <Loader />
                        </div>
                      )}
                      {!isDataLoading && !isNotFound && (
                        <form className="form-border-1" onSubmit={handleSubmit}>
                          <div className="mb-8">
                            <label
                              htmlFor="product_title"
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                            >
                              title
                            </label>
                            <input
                              type="text"
                              name="title"
                              placeholder="Type here"
                              className="form-control"
                              value={product.title}
                              onChange={handleInputChange}
                              id="product_title"
                              required
                            />
                          </div>
                          {canProductInputs && (
                            <>
                            <div className="mb-8">
                              <label
                                className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                                htmlFor="currency"
                              >
                                Choose Product Status
                              </label>
                              <select
                                className="form-select"
                                name="status"
                                value={product.status}
                                onChange={handleInputChange}
                                required
                              >
                                <option defaultValue="">Choose</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                                <option value="Dormant">Dormant</option>
                              </select>
                            </div>
                            <div className="mb-8">
                              <label
                                className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                                htmlFor="currency"
                              >
                                Choose Product Type
                              </label>
                              <select
                                className="form-select"
                                name="type"
                                value={product.type}
                                onChange={handleInputChange}
                                required
                              >
                                <option defaultValue="">Choose</option>
                                <option value="GSL">GSL</option>
                                <option value="P-Med">P-Med</option>
                                <option value="P-CAT-D">P-CAT-D</option>
                              </select>
                            </div>

                            <div className="mb-4">
                              <div className="d-flex align-items-center">
                                <input
                                  className="form-check-input rounded-0 ms-0"
                                  type="checkbox"
                                  name="enableEbayMessage"
                                  checked={product.enableEbayMessage}
                                  onChange={handleInputChange}
                                />
                                <div style={{ marginLeft: "10px" }}>
                                  <label htmlFor="enableEbayMessage">
                                    Enable Message on Purchase
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="mb-8">
                              <label
                                htmlFor="product_title"
                                className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              >
                                Message Content
                              </label>
                              <textarea
                                className="form-control"
                                rows={7}
                                placeholder="write your message here.."
                                value={product.ebayMessageContent}
                                onChange={handleInputChange}
                                name="ebayMessageContent"
                              />
                            </div>
                            <div className="mb-8">
                              <label
                                htmlFor="product_title"
                                className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              >
                                Message Attachment
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) =>
                                  setProduct({
                                    ...product,
                                    image: e.target.files[0],
                                  })
                                }
                              />
                            </div>
                            {product?.ebayImage?.public_id && (
                              <img
                                src={`${backend_ul}/uploads/${product.ebayImage.public_id}`}
                                alt="Product Image"
                                style={{ maxWidth: "100%", height: "auto" }}
                              />
                            )}
                            <div className="mb-8">
                              <label
                                htmlFor="product_title"
                                className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              >
                                Purchase Limit Days
                              </label>
                              <input
                                type="number"
                                name="purchaseLimitDays"
                                placeholder="Days limit"
                                className="form-control"
                                value={product.purchaseLimitDays}
                                onChange={handleInputChange}
                                id="product_title"
                              />
                            </div>
                            </>
                          )}

                          <div className="col-sm-12 d-flex flex-wrap justify-content-sm-end">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isLoading}
                            >
                              {isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}{" "}
                              Update
                            </button>
                          </div>
                        </form>
                      )}
                      {!isDataLoading && isNotFound && (
                        <div className="text-center">
                          <img
                            src="/assets/images/no-data.png"
                            style={{ width: "60px", opacity: "0.5" }}
                            alt=""
                          />
                          <h6
                            style={{
                              color: "#918f8f",
                              fontFamily: "math",
                              fontWeight: "500",
                            }}
                          >
                            No Data Found
                          </h6>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {variations && variations.length > 0 && (
              <form onSubmit={handleVariationSubmit} className="form-border-1">
                <div className="row mt-4">
                  {variations.map((variation, index) => (
                    <div className="col-lg-4" key={index}>
                      <div className="card mb-8 rounded-4">
                        <div className="card-header d-flex justify-content-between align-items-center flex-nowrap gap-2">
                          <h6
                            className="mb-0 text-truncate"
                            style={{ maxWidth: "60%" }}
                          >
                            {variation.SKU}
                          </h6>
                          <div className="d-flex flex-shrink-0 gap-2">
                            <ProductInventory 
                              sqlProducts={sqlProducts}
                              variation={variation}
                              index={index}
                              variations={variations}
                              setVariations={setVariations}
                              product={product}
                              setCurrentVariationIndex={setCurrentVariationIndex}
                              currentVariationIndex={currentVariationIndex}
                              vatCategories={vatCategories}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => handleShowModal(index, variation)}
                            >
                              <i className="fa fa-ellipsis-h"></i>
                            </button>
                          </div>
                        </div>

                        <div className="card-body">
                          {(() => {
                            const assignedProducts = (variation.inventory?.products || []).filter(p => p.id && p.quantity);
                            return assignedProducts.length > 0 ? (
                              <div className="mb-8 p-2 rounded" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" }}>
                                {assignedProducts.map((p, pi) => {
                                  const label = sqlProducts.find(opt => opt.value === p.id)?.label || p.id;
                                  return (
                                    <div key={pi} className="d-flex justify-content-between align-items-center" style={{ fontSize: "12px" }}>
                                      <span className="text-truncate me-2" style={{ maxWidth: "75%" }}>{label}</span>
                                      <span className="badge bg-secondary">×{p.quantity}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div className="mb-8 text-center py-1 rounded" style={{ backgroundColor: "#fff3f3", border: "1px solid #f5c6cb", fontSize: "12px", color: "#dc3545", fontWeight: 600 }}>
                                <i className="fa fa-exclamation-triangle me-1"></i> NO INVENTORY PRODUCT ASSIGNED
                              </div>
                            );
                          })()}
                          <div className="mb-8">
                            <label
                              htmlFor={`name_${index}`}
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                            >
                              Name
                            </label>
                            <input
                              type="text"
                              name="name"
                              placeholder="Type here"
                              className="form-control"
                              id={`name_${index}`}
                              value={variation.name || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "name", e.target.value)
                              }
                            />
                          </div>

                          {/* Add Risk Level Select Input Here */}
                          <div className="mb-8">
                            <label
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              htmlFor={`riskLevel_${index}`}
                            >
                              Risk Level
                            </label>
                            <select
                              className="form-select"
                              name="riskLevel"
                              value={variation.riskLevel || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "riskLevel", Number(e.target.value))
                              }
                              required
                            >
                              <option value="">Choose Risk Level</option>
                              {Array.from({ length: 57 }, (_, i) => i + 14).map((number) => (
                                <option key={number} value={number}>
                                  {number}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mb-8">
                            <label
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              htmlFor={`format_${index}`}
                            >
                              Choose Format
                            </label>
                            <select
                              className="form-select"
                              name="format"
                              value={variation.format || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "format", e.target.value)
                              }
                              required
                            >
                              <option value="">Choose</option>
                              {PRODUCT_FORMATS.map((formatOption) => (
                                <option key={formatOption} value={formatOption}>
                                  {formatOption}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Weight (g)</label>
                            <input
                              type="text"
                              name="weight"
                              placeholder="Type here"
                              className="form-control"
                              value={variation.weight || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "weight", e.target.value)
                              }
                              required
                            />
                          </div>

                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Length (cm)</label>
                            <input
                              type="text"
                              name="length"
                              placeholder="Type here"
                              className="form-control"
                              value={variation.length || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "length", e.target.value)
                              }
                              required
                            />
                          </div>

                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Width (cm)</label>
                            <input
                              type="text"
                              name="width"
                              placeholder="Type here"
                              className="form-control"
                              value={variation.width || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "width", e.target.value)
                              }
                              required
                            />
                          </div>

                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Height (cm)</label>
                            <input
                              type="text"
                              name="height"
                              placeholder="Type here"
                              className="form-control"
                              value={variation.height || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "height", e.target.value)
                              }
                              required
                            />
                          </div>

                          <div className="mb-8">
                            <label
                              htmlFor={`limit_${index}`}
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                            >
                              Limit
                            </label>
                            <input
                              type="number"
                              name="limit"
                              placeholder="Type here"
                              className="form-control"
                              value={variation.limit || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "limit", e.target.value)
                              }
                            />
                          </div>

                          {/*  Preferred Brand */}
                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Preferred Brand</label>
                            <input
                              type="text"
                              className="form-control"
                              value={variation.preferredBrand || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "preferredBrand", e.target.value)
                              }
                              placeholder="Enter brand"
                            />
                          </div>

                          {/*  Flat Packed */}
                          <div className="mb-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`flatPacked_${index}`}
                                checked={variation.flatPacked || false}
                                onChange={(e) =>
                                  handleVarInputChange(index, "flatPacked", e.target.checked)
                                }
                              />
                              <label className="form-check-label" htmlFor={`flatPacked_${index}`}>
                                Flat Packed
                              </label>
                            </div>
                          </div>

                          {/*  Extra Protection */}
                          <div className="mb-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`extraProtection_${index}`}
                                checked={variation.extraProtection || false}
                                onChange={(e) =>
                                  handleVarInputChange(index, "extraProtection", e.target.checked)
                                }
                              />
                              <label className="form-check-label" htmlFor={`extraProtection_${index}`}>
                                Extra Protection
                              </label>
                            </div>
                          </div>

                          {/*  Packaging Type */}
                          <div className="mb-8">
                            <label className="mb-4 fs-13px ls-1 fw-bold text-uppercase">Packaging Type</label>
                            <select
                              className="form-select"
                              value={variation.packagingType || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "packagingType", e.target.value)
                              }
                            >
                              <option value="">Choose</option>
                              <option value="Small Mailing Bag">Small Mailing Bag</option>
                              <option value="Medium Mailing Bag">Medium Mailing Bag</option>
                              <option value="Large Mailing Bag">Large Mailing Bag</option>
                              <option value="Small Jiffy Bag C/0">Small Jiffy Bag C/0</option>
                              <option value="Medium Jiffy Bag F/3">Medium Jiffy Bag F/3</option>
                              <option value="Large Jiffy Bag J/6">Large Jiffy Bag J/6</option>
                              <option value="Small Box">Small Box</option>
                              <option value="Medium Box">Medium Box</option>
                              <option value="Large Box">Large Box</option>
                              <option value="C4 PIP Boxes">C4 PIP Boxes</option>
                              <option value="C5 PIP Boxes">C5 PIP Boxes</option>
                              <option value="C6 PIP Boxes">C6 PIP Boxes</option>
                            </select>
                          </div>

                          {/*  Postage Section */}
                          {postages && postages.length > 0 && (
                            <>
                              {postages.map((postage, pIndex) => {
                                if (postage.name?.toUpperCase().includes('INTL')) return null;
                                return (<div className="mb-8" key={`${index}_${pIndex}`}>
                                  <label
                                    htmlFor={`postage_${index}_${pIndex}`}
                                    className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                                  >
                                    {postage.name}{" "}
                                    <span style={{ fontSize: "10px" }}>({postage.type})</span>
                                    {isAmazonDefaultPostage(
                                      variation.shippingTemplateName,
                                      postage.name
                                    ) && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            <div style={{ textAlign: "left" }}>
                                              {AMAZON_DEFAULT_POSTAGE_HINT}
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="fa fa-info-circle ms-1 text-primary"
                                          style={{ cursor: "pointer" }}
                                          role="img"
                                          tabIndex={0}
                                          aria-label={AMAZON_DEFAULT_POSTAGE_HINT}
                                        ></i>
                                      </OverlayTrigger>
                                    )}
                                  </label>
                                  <select
                                    className="form-select"
                                    name={`postageCode_${index}_${pIndex}`}
                                    value={
                                      variation.postage?.[pIndex]?.name === postage.name
                                        ? variation.postage?.[pIndex]?.code
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleVarPostageChange(
                                        index,
                                        pIndex,
                                        e.target.value,
                                        postage.name
                                      )
                                    }
                                  >
                                    <option value="">Choose</option>
                                    {postageCodes.map((item, cIndex) => (
                                      <option key={cIndex} value={item.code}>
                                        {item.code}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                );
                              })}
                            </>
                          )}
                          <div className="mb-8">
                            <label
                              className="mb-4 fs-13px ls-1 fw-bold text-uppercase"
                              htmlFor={`location${index}`}
                            >
                              Location
                            </label>
                            <select
                              className="form-select"
                              name="location"
                              value={variation.location || ""}
                              onChange={(e) =>
                                handleVarInputChange(index, "location", e.target.value)
                              }
                              required
                            >
                              <option value="">Choose</option>
                              <option value="MI Health Longcroft House">MI Health Longcroft House</option>
                              <option value="Berkeley Care Unit">Berkeley Care Unit</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-12 text-center">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isVarSubmit}
                  >
                    {isVarSubmit && <i className="fa fa-spinner fa-spin"></i>}{" "}
                    {isVarSubmit ? "Please Wait" : "Update Variations"}
                  </button>
                </div>
              </form>
            )}  
          </div>
        </div>

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Variation Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Goods Description</label>
              <input
                type="text"
                className="form-control"
                name="goodsDescription"
                value={variationDetails.goodsDescription}
                onChange={handleDetailChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">HS Code</label>
              <input
                type="text"
                className="form-control"
                name="hsCode"
                value={variationDetails.hsCode}
                onChange={handleDetailChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Extended Good Description</label>
              <textarea
                className="form-control"
                name="extendedGoodDescription"
                value={variationDetails.extendedGoodDescription}
                onChange={handleDetailChange}
                rows={3}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={saveVariationDetails} disabled={isLoading}>
               {isLoading ? 'Saving...' : 'Save Changes'}
            </Button>
          </Modal.Footer>
        </Modal>

      </Layout>
    </>
  );
};

export default ProductEdit;
